"use client";

import mixpanel from "mixpanel-browser";
import dynamic from "next/dynamic";
import { useEffect } from "react";
import {
  FB_PIXEL_ID,
  getUtmParams,
  NEXT_PUBLIC_MIXPANEL_TOKEN,
} from "utils/common";

const Chat = dynamic(
  () => {
    return import("components/Chat");
  },
  { ssr: false }
);

export default function Home() {
  useEffect(() => {
    mixpanel.init(NEXT_PUBLIC_MIXPANEL_TOKEN, {
      debug: true,
      persistence: "localStorage",
    });
    mixpanel.track_pageview({
      page: "Hito landing page",
      ...getUtmParams(window.location.href),
    });
    import("react-facebook-pixel")
      .then((module) => module.default)
      .then((ReactPixel) => {
        ReactPixel.init(FB_PIXEL_ID);
        ReactPixel.pageView();
        ReactPixel.trackCustom("Hito landing page", {
          ...getUtmParams(window.location.href),
        });
      });
  }, []);

  return (
    <div className="bg-[#F2F1E9] ">
      <Chat />
    </div>
  );
}
